/* eslint-disable import/no-mutable-exports */
// Browser-side implementation
let apmInstance;

// Create a mock APM client with no-op methods
const mockApmClient = {
  captureError: () => {},
  setUserContext: () => {},
  setCustomContext: () => {},
  addLabels: () => {},
  startTransaction: () => ({
    end: () => {},
    addLabels: () => {},
  }),
  getCurrentTransaction: () => null,
};

try {
  if (window.elasticApm) {
    apmInstance = window.elasticApm;
  } else {
    apmInstance = mockApmClient;
  }
} catch (e) {
  apmInstance = mockApmClient;
}

export default apmInstance;
